import React from "react";

export const EditInputIcon = (props) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid={props["data-testid"]}
      onClick={props.onClick}
      style={{ cursor: "pointer" }}
    >
      <circle
        cx="12.5"
        cy="12.5"
        r="12.5"
        fill="#EBEBEB"
        style={{
          fill: "#EBEBEB",
          fill: "color(display-p3 0.9216 0.9216 0.9216)",
          fillOpacity: 1,
        }}
      />
      <path
        d="M15.3183 6.57812L17.4795 8.99479L15.8319 10.8379L13.6707 8.42124L15.3183 6.57812ZM7.40234 17.8462H9.56359L14.8133 11.9762L12.652 9.55949L7.40234 15.4296V17.8462Z"
        fill="#353535"
        style={{
          fill: "#353535",
          fill: "color(display-p3 0.2089 0.2066 0.2066)",
          fillOpacity: 1,
        }}
      />
    </svg>
  );
};
